import { includes, findIndex } from 'lodash';
import { matchPath } from 'react-router';
import { initializeLeadersForRoute } from '../redux/actions/leaders';

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const routes = {
  GET_STARTED: 'get_started',
  TRAVEL: 'travel',
  HOME: 'home',
  FOOD: 'food',
  SHOPPING: 'shopping',
  TAKE_ACTION: 'take_action',
  MISSING_ROUTE: 'missing',
};

export const makePathConfigs = t => [
  { pathname: '/:locale?', route: routes.GET_STARTED },
  { pathname: `/:locale?/${t(routes.GET_STARTED)}`, route: routes.GET_STARTED },
  { pathname: `/:locale?/${t(routes.TRAVEL)}`, route: routes.TRAVEL },
  { pathname: `/:locale?/${t(routes.HOME)}`, route: routes.HOME },
  { pathname: `/:locale?/${t(routes.FOOD)}`, route: routes.FOOD },
  { pathname: `/:locale?/${t(routes.SHOPPING)}`, route: routes.SHOPPING },
  { pathname: `/:locale?/${t(routes.TAKE_ACTION)}`, route: routes.TAKE_ACTION },
];

export const pathConfigs = (i18n) => {
  const t = i18n.getFixedT(null, 'routes');
  return makePathConfigs(t);
};

export const calculatorPages = [
  routes.GET_STARTED,
  routes.TRAVEL,
  routes.HOME,
  routes.FOOD,
  routes.SHOPPING,
  routes.TAKE_ACTION,
];

const calculatorPageTitles = {
  [routes.GET_STARTED]: 'Get Started',
  [routes.TRAVEL]: 'Travel',
  [routes.HOME]: 'Home',
  [routes.FOOD]: 'Food',
  [routes.SHOPPING]: 'Shopping',
  [routes.TAKE_ACTION]: 'Take Action',
};

export const getRouteTitle = (route, i18n) => i18n.t(calculatorPageTitles[route], { ns: 'pageTitles' });

export const getPreviousRoute = (route) => {
  const routeIndex = calculatorPages.indexOf(route);
  if (routeIndex === 0) return null;
  return calculatorPages[routeIndex - 1];
};

export const getNextRoute = (route) => {
  const routeIndex = calculatorPages.indexOf(route);
  if (routeIndex + 1 >= calculatorPages.length) return null;
  return calculatorPages[routeIndex + 1];
};

export const getCurrentRoute = (location, i18n) => {
  const matchingConfig = pathConfigs(i18n).find(config => matchPath(location.pathname, {
    path: config.pathname,
    exact: true,
    strict: false,
  }));

  return matchingConfig ? matchingConfig.route : routes.MISSING_ROUTE;
};

export const getCurrentRouteIndex = (location, i18n) => findIndex(
  pathConfigs(i18n),
  config => Boolean(matchPath(location.pathname, {
    path: config.pathname,
    exact: true,
    strict: false,
  })),
);

export const nextCalculatorPage = (location, history, i18n) => {
  const t = i18n.getFixedT(null, 'routes');
  const matchingConfig = pathConfigs(i18n).find(config => matchPath(location.pathname, {
    path: config.pathname,
    exact: true,
    strict: false,
  }));
  if (!matchingConfig) return;
  const nextRoute = getNextRoute(matchingConfig.route);
  if (nextRoute === null) return;
  history.push(`/${i18n.language}/${t(nextRoute)}`);
};

export const previousCalculatorPage = (location, history, i18n) => {
  const t = i18n.getFixedT(null, 'routes');
  const matchingConfig = pathConfigs(i18n).find(config => matchPath(location.pathname, {
    path: config.pathname,
    exact: true,
    strict: false,
  }));
  if (!matchingConfig) return;
  const previousRoute = getPreviousRoute(matchingConfig.route);
  history.push(`/${i18n.language}/${t(previousRoute)}`);
};

const visited = [];

const notifyWidgetPageVisited = (routeName) => {
  if (includes(visited, routeName)) return;
  if (!includes(calculatorPages, routeName)) return;

  visited.push(routeName);

  if (!window.parentIFrame) return;
  const message = {
    type: 'page:visited',
    data: {
      visited,
      allPagesVisited: visited.length === calculatorPages.length,
    },
  };
  window.parentIFrame.sendMessage(JSON.stringify(message));
};
const notifyWidgetTakeActionVisited = (routeName) => {
  if (!window.parentIFrame) return;

  if (routeName === routes.TAKE_ACTION) {
    const message = {
      type: 'onTakeActionVisited',
    };
    window.parentIFrame.sendMessage(JSON.stringify(message));
  }
  const message = {
    type: 'onNavigate',
  };
  window.parentIFrame.sendMessage(JSON.stringify(message));
};

export const initializeHistory = (history, i18n, store) => {
  const initialRoute = getCurrentRoute(history.location, i18n);
  // notify widget page visited current location.
  notifyWidgetPageVisited(initialRoute);
  notifyWidgetTakeActionVisited(initialRoute);
  // load initial list of leaders.
  initializeLeadersForRoute(initialRoute)(store.dispatch, store.getState);
  // as well as any subsequent changes.
  history.listen((location, _action) => {
    const newRoute = getCurrentRoute(location, i18n);
    notifyWidgetPageVisited(newRoute);
    notifyWidgetTakeActionVisited(newRoute);
    initializeLeadersForRoute(newRoute)(store.dispatch, store.getState);
  });
};

export const goToRouteByName = (route, history, i18n) => {
  const t = i18n.getFixedT(null, 'routes');
  window.jQuery("[data-toggle='popover']").popover('hide');
  history.push(`/${i18n.language}/${t(route)}`);
};

const formatLanguageCode = (code) => {
  // http://www.iana.org/assignments/language-tags/language-tags.xhtml
  if (typeof code === 'string' && code.indexOf('-') > -1) {
    const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
    const p = code.split('-');

    if (p.length === 2) {
      p[0] = p[0].toLowerCase();
      p[1] = p[1].toUpperCase();

      if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
    } else if (p.length === 3) {
      p[0] = p[0].toLowerCase();

      // if lenght 2 guess it's a country
      if (p[1].length === 2) p[1] = p[1].toUpperCase();
      if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

      if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
    }

    return p.join('-');
  }

  return code;
};

const lookupLanguageNavigator = () => {
  const found = [];

  if (typeof navigator !== 'undefined') {
    // chrome only; not an array
    // so can't use .push.apply instead of iterating
    if (navigator.languages) {
      navigator.languages.forEach((lang) => {
        found.push(lang);
      });
    }
    if (navigator.userLanguage) {
      found.push(navigator.userLanguage);
    }
    if (navigator.language) {
      found.push(navigator.language);
    }
  }

  return found.length > 0 ? formatLanguageCode(found[0]) : undefined;
};

export const getLocaleFromWindowLocation = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(new RegExp('^/?(\\w{2,5})(/|$)'));
  if (!match) {
    return lookupLanguageNavigator() || 'en';
  }
  return match[1];
};
